import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PtlFormsModule, FormPageActionsService } from '@ptl/forms';

import { PlanEnrollmentComponent } from './plan-enrollment/plan-enrollment.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { MaterialGlobalModule } from '../../shared/modules/material-global.module';
import { PageGuaranteedIssueEligibilityComponent } from './plan-enrollment/formComponents/page-guaranteed-issue-eligibility/page-guranteed-issue-eligibility.component';
import { PageReviewComponent } from './plan-enrollment/formComponents/page-review/page-review.component';
import { PagePreauthorizationComponent } from './medigap-preauthorization/page-preauthorization/page-preauthorization.component';
import { addWhbQuestionComponent } from './medigap-preauthorization/add-whb-question/add-whb-question.component';

import { CoverageDropdownSelectComponent } from './form-components/coverage-dropdown-select/coverage-dropdown-select.component';
import { NgReduxFormModule } from '@ptl/angular-redux-form';
import { NgReduxModule } from '@ptl/angular-redux-store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InnerHtmlComponent } from './form-components/inner-html/inner-html.component';
import { MappedContentComponent } from './form-components/mapped-content/mapped-content.component';

import { PtlGlobalComponentsModule } from '@ptl/global-components';
import { EntryZipCountyInputsComponent } from './plan-enrollment/formComponents/entry-zip-county-inputs/entry-zip-county-inputs.component';
import { EntryZipCountyReviewComponent } from './plan-enrollment/formComponents/entry-zip-county-inputs/entry-zip-county-review/entry-zip-county-review.component';

import { ShopXFormPageActionsService } from './services/shopx-form-page-actions.service';
import { HealthCheckMedicationComponent } from './form-components/health-check-medication/health-check-medication.component';
import { PageCreateFamilyComponent } from './family-form/page-create-family/page-create-family.component';
import { AddControlsComponent } from './form-components/add-controls/add-controls.component';

import { LoadFormComponent } from './load-form/load-form.component';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { HyperlinkComponent } from './form-components/hyperlink/hyperlink.component';
import { HyperlinkResetCloseComponent } from './form-components/hyperlink-reset-close/hyperlink-reset-close.component';
import { WholeHealthBalanceCheckboxComponent } from './medigap-preauthorization/whole-health-balance-checkbox/whole-health-balance-checkbox.component';
import { MaskingDirective } from 'src/app/shared/directives/masking.directive';
import { CustomRadioInputComponent } from './form-components/custom-radio-input/custom-radio-input.component';
import { DateOfBirthInputComponent } from './form-components/date-of-birth-input/date-of-birth-input.component';
import { LifeEventSinglePageProxyFormComponent } from './form-components/special-enrollment-single-page-proxy/proxy-forms/life-event-single-page-proxy-form/life-event-single-page-proxy-form.component';
import { DateOfLifeEventSinglePageProxyFormComponent } from './form-components/special-enrollment-single-page-proxy/proxy-forms/date-of-life-event-single-page-proxy-form/date-of-life-event-single-page-proxy-form.component';
import { ApplicableCircumstanceSinglePageProxyFormComponent } from './form-components/special-enrollment-single-page-proxy/proxy-forms/applicable-circumstance-single-page-proxy-form/applicable-circumstance-single-page-proxy-form.component';

import { PageIndividualPlanEnrollmentComponent } from './plan-enrollment/individual-plan-enrollment-form/page-individual-plan-enrollment/page-individual-plan-enrollment.component';
import { IndividualMarketEffectiveDateSelectComponent } from './form-components/individual-market-effective-date-select/individual-market-effective-date-select.component';
import { SpousalPartnerComponent } from './form-components/individual-market-persons/spousal-partner/spousal-partner.component';
import { IndividualComponent } from './form-components/individual-market-persons/individual/individual.component';
import { DependentsComponent } from './form-components/individual-market-persons/dependents/dependents.component';
import { IndividualMarketPersonsComponent } from './form-components/individual-market-persons/individual-market-persons.component';
import { FormDoctorInformation } from './form-components/form-doctor-information/form-doctor-information.component';
import { MedicalInformationModule } from '../medical-information/medical-information.module';
import { ApplicantInfoReviewComponent } from './form-components/applicant-info-review/applicant-info-review.component';
import { EffectiveDateAttestationComponent } from './form-components/effective-date-attestation/effective-date-attestation.component';
import { IndividualPageReviewV2Component } from './plan-enrollment/individual-plan-enrollment-form/individual-page-review-v2/individual-page-review-v2.component';
import { IndividualPageReviewComponent } from './plan-enrollment/individual-plan-enrollment-form/individual-page-review/individual-page-review.component';
import { ProducerFileUploadFormComponent } from './form-components/producer-file-upload/producer-file-upload.component';
import { ProducerFileUploadComponent } from './form-components/producer-file-upload/producer-file-upload/producer-file-upload.component';
import { MedicareInfoValidatorComponent } from './form-components/medicare-info-validator/medicare-info-validator.component';
import { StatementsOfAuthorizationComponent } from './plan-enrollment/formComponents/statements-of-authorization/statements-of-authorization.component';

import { CustomStatementAuthComponent } from './form-components/custom-statement-auth/custom-statement-auth.component';
import { SoaStatusLookupComponent } from './form-components/soa-status-lookup/soa-status-lookup.component';
import { CustomZipCodeLabelComponent } from './form-components/custom-zip-code-label/custom-zip-code-label.component';
import { TextAreaComponent } from './form-components/text-area/text-area.component';
import { AuthRepSignComponent } from './form-components/auth-rep-sign/auth-rep-sign.component';
import { PagePublicConfirmationComponent } from './soa-form/page-public-confirmation/page-public-confirmation.component';
import { PageAgentConfirmationComponent } from './soa-form/page-agent-confirmation/page-agent-confirmation.component';
import { SendSoaPageComponent } from './soa-form/page-send-soa/page-send-soa.component';
import { AgencySelectorDropdownComponent } from './form-components/agency-selector-dropdown/agency-selector-dropdown.component';
import { ConflictingEffectiveDateModalComponent } from './form-components/effective-date-attestation/conflicting-effective-date-modal/conflicting-effective-date-modal.component';
import { HealthCheckMedicationReviewComponent } from './form-components/health-check-medication/health-check-medication-review/health-check-medication-review.component';
import { ReviewEffectiveDateAttestationComponent } from './form-components/effective-date-attestation/review-effective-date-attestation/review-effective-date-attesation.component';
import { PlanEnrollmentOnExchangeComponent } from './plan-enrollment-on-exchange/plan-enrollment-on-exchange.component';
import { PageIndividualOnExchangePlanEnrollmentComponent } from './plan-enrollment-on-exchange/page-individual-on-exchange-plan-enrollment/page-individual-on-exchange-plan-enrollment.component';
import { MarketplaceReviewApplicationComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-review-application/marketplace-review-application.component';
import { MarketplaceNotificationAndAuthorizationComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-notification-and-authorization/marketplace-notification-and-authorization.component';
import { MarketplaceProducerAuthorizationComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-producer-authorization/marketplace-producer-authorization.component';
import { MarketplaceConsumerNpnComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-consumer-npn/marketplace-consumer-npn.component';
import { MarketplaceAdvancePremiumTaxCreditComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-advance-premium-tax-credit/marketplace-advance-premium-tax-credit.component';
import { PageIndividualOnExchangePlanEnrollmentPaymentComponent } from './plan-enrollment-on-exchange/page-individual-on-exchange-plan-enrollment-payment/page-individual-on-exchange-plan-enrollment-payment.component';
import { MarketplacePaymentOptionsComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-payment-options/marketplace-payment-options.component';
import { FormIndividualOnExchangePlanEnrollmentPaymentComponent } from './plan-enrollment-on-exchange/form-individual-on-exchange-plan-enrollment-payment/form-individual-on-exchange-plan-enrollment-payment.component';
import { MarketplacePaymentInfoComponent } from './plan-enrollment-on-exchange/formComponents/marketplace-payment-info/marketplace-payment-info.component';
import { PagePlanChangeStartReviewComponent } from './plan-enrollment/formComponents/page-plan-change-start-review/page-plan-change-start-review.component';
import { PlanChangeMemberLookupComponent } from './form-components/plan-change-member-lookup/plan-change-member-lookup.component';
import { PageSendReferralComponent } from './purl-form/page-send-referral/page-send-referral.component';
import { SpecialEnrollmentEventReasonComponent } from './form-components/special-enrollment-event-reason/special-enrollment-event-reason.component';
import { SpecialEnrollmentEventDocumentUploadComponent } from './form-components/special-enrollment-event-document-upload/special-enrollment-event-document-upload.component';
import { ViewPlansDropdownComponent } from './form-components/view-plans-dropdown/view-plans-dropdown.component';
import { SpecialEnrollmentEventDocumentUploadIchraAndQsehraComponent } from './form-components/special-enrollment-event-document-upload/variants/special-enrollment-event-document-upload-ichra-and-qsehra/special-enrollment-event-document-upload-ichra-and-qsehra.component';
import { SpecialEnrollmentEventInfoComponent } from './form-components/special-enrollment-event-info/special-enrollment-event-info.component';
import { FormDoctorInformationReview } from './form-components/form-doctor-information-review/form-doctor-information.component-review';
import { DocumentOrderFormComponent } from './document-order-form/document-order-form.component';
import { AutoCompleteInputAddressesComponent } from './form-components/autocomplete-addresses/autocomplete-input-addresses.component';
import { CommonFormMemberLookupComponent } from './form-components/common-form-member-lookup/common-form-member-lookup.component';
import { WholeHealthBalanceMemberLookupComponent } from './form-components/whb-member-lookup/whb-member-lookup.component';
import { WhbConsumerLoginComponent } from './form-components/whb-consumer-login/whb-consumer-login.component';
import { SendOutlineOfCoverageComponent } from './form-components/send-outline-of-coverage/send-outline-of-coverage.component';
import { SendOutlineOfCoverageReviewComponent } from './form-components/send-outline-of-coverage/send-outline-of-coverage-review/send-outline-of-coverage-review.component';
import { PageDsnpEnrollmentComponent } from './form-components/page-dsnp-enrollment/page-dsnp-enrollment.component';
import { AdaptiveYearSelectorComponent } from './form-components/adaptive-year-selector/adaptive-year-selector.component';
import { SpecialEnrollmentEventSelectorComponent } from './form-components/special-enrollment-event-selector/special-enrollment-event-selector.component';
import { SpecialEnrollmentDateOfLifeEventComponent } from './form-components/special-enrollment-date-of-life-event/special-enrollment-date-of-life-event.component';
import { AgentCertificateComponent } from './form-components/agent-certificate/agent-certificate.component';
import { PagePreauthAndEligibilityComponent } from './medigap-preauthorization/page-preauth-and-eligibility/page-preauth-and-eligibility.component';
import { DynamicSpecialEnrollmentEventDocumentUpload } from './form-components/special-enrollment-event-document-upload/variants/dynamic-special-enrollment-event-document-upload/dynamic-special-enrollment-event-document-upload.component';
import { NoteEditorModalComponent } from './form-components/note-editor-modal/note-editor-modal.component';
import { ProducerModule } from '../producer/producer.module';
import { StateModuleReadyService } from '@ptl/state';
import { SpecialEnrollmentDateOfLifeEventProxyComponent } from './form-components/special-enrollment-date-of-life-event-proxy/special-enrollment-date-of-life-event-proxy.component';
import { SpecialEnrollmentEventSelectorProxyComponent } from './form-components/special-enrollment-event-selector-proxy/special-enrollment-event-selector-proxy.component';
import { SpecialEnrollmentSinglePageProxyComponent } from './form-components/special-enrollment-single-page-proxy/special-enrollment-single-page-proxy.component';
import { PageCreateFamilySpecialEnrollmentComponent } from './family-form/page-create-family-special-enrollment/page-create-family-special-enrollment.component';
import { MassUploadFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-form-control.component';
import { MassUploadHiosIdFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-hios-id-form-control.component';
import { MassUploadZipCodeFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-zip-code-form-control.component';
import { MassUploadCountyFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-county-form-control.component';
import { MassUploadEffectiveDateFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-effective-date-form-control.component';
import { MassUploadStatusFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-status-form-control/mass-upload-status-form-control.component';
import { MassUploadPlanRegionFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-plan-region-form-control.component';
import { MassUploadStateFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-state-form-control/mass-upload-state-form-control.component';
import { MassUploadDateFormControlComponent } from './form-components/mass-upload-form-control/mass-upload-special-controls/mass-upload-date-form-control/mass-upload-date-form-control.component';

//Required Docs Upload Components + Module
import { RequiredDocsUploadModule } from './form-components/required-docs-upload/required-docs-upload.module';
import { RequiredDocsUploadReviewComponent } from './form-components/required-docs-upload/required-docs-upload-review/required-docs-upload-review.component';
import { RequiredDocsUploadSpecialEnrollmentComponent } from './form-components/required-docs-upload/required-docs-upload/variants/required-docs-upload-special-enrollment/required-docs-upload-special-enrollment.component';
import { ByteFormatterPipe } from './form-components/required-docs-upload/byte-formatter.pipe';
import { FileDisplayComponent } from './form-components/required-docs-upload/file-display/file-display.component';
import { DynamicDocsUploadSpecialEnrollmentComponent } from './form-components/required-docs-upload/required-docs-upload/variants/dynamic-docs-upload-special-enrollment/dynamic-docs-upload-special-enrollment.component';
import { RequiredDocsUploadFormComponent } from './form-components/required-docs-upload/required-docs-upload-form.component';
import { FileDisplayWithDropdownComponent } from './form-components/required-docs-upload/file-display/variants/file-display-with-dropdown/file-display-with-dropdown.component';
import { FileDisplayWithModalComponent } from './form-components/required-docs-upload/file-display/variants/file-display-with-modal/file-display-with-modal.component';
@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    PtlFormsModule,
    MaterialGlobalModule,
    NgReduxModule,
    NgReduxFormModule,
    FormsModule,
    ReactiveFormsModule,
    PtlGlobalComponentsModule,
    MedicalInformationModule,
    ProducerModule,
    RequiredDocsUploadModule
  ],
  exports: [
    PlanEnrollmentComponent,
    LoadFormComponent,
    MaskingDirective,
    RequiredDocsUploadModule
  ],
  declarations: [
    AddControlsComponent,
    addWhbQuestionComponent,
    AgencySelectorDropdownComponent,
    ApplicantInfoReviewComponent,
    AuthRepSignComponent,
    ConflictingEffectiveDateModalComponent,
    CoverageDropdownSelectComponent,
    CustomRadioInputComponent,
    AutoCompleteInputAddressesComponent,
    CustomStatementAuthComponent,
    CustomZipCodeLabelComponent,
    DependentsComponent,
    EffectiveDateAttestationComponent,
    ReviewEffectiveDateAttestationComponent,
    EntryZipCountyInputsComponent,
    EntryZipCountyReviewComponent,
    FormDoctorInformation,
    FormDoctorInformationReview,
    HealthCheckMedicationComponent,
    HealthCheckMedicationReviewComponent,
    HyperlinkComponent,
    HyperlinkResetCloseComponent,
    IndividualComponent,
    IndividualMarketEffectiveDateSelectComponent,
    IndividualMarketPersonsComponent,
    IndividualPageReviewV2Component,
    IndividualPageReviewComponent,
    InnerHtmlComponent,
    LoadFormComponent,
    MappedContentComponent,
    MaskingDirective,
    MedicareInfoValidatorComponent,
    PageAgentConfirmationComponent,
    PageCreateFamilyComponent,
    PageGuaranteedIssueEligibilityComponent,
    PageIndividualPlanEnrollmentComponent,
    PagePreauthorizationComponent,
    PagePreauthAndEligibilityComponent,
    PagePublicConfirmationComponent,
    PageReviewComponent,
    PlanEnrollmentComponent,
    ProducerFileUploadComponent,
    ProducerFileUploadFormComponent,
    SendSoaPageComponent,
    SoaStatusLookupComponent,
    SpousalPartnerComponent,
    StatementsOfAuthorizationComponent,
    TextAreaComponent,
    WholeHealthBalanceCheckboxComponent,
    PageIndividualOnExchangePlanEnrollmentComponent,
    PlanEnrollmentOnExchangeComponent,
    MarketplaceReviewApplicationComponent,
    MarketplaceAdvancePremiumTaxCreditComponent,
    MarketplaceNotificationAndAuthorizationComponent,
    MarketplaceProducerAuthorizationComponent,
    MarketplaceConsumerNpnComponent,
    PageIndividualOnExchangePlanEnrollmentPaymentComponent,
    MarketplacePaymentOptionsComponent,
    FormIndividualOnExchangePlanEnrollmentPaymentComponent,
    MarketplacePaymentInfoComponent,
    PagePlanChangeStartReviewComponent,
    PlanChangeMemberLookupComponent,
    PageSendReferralComponent,
    ViewPlansDropdownComponent,
    SpecialEnrollmentEventDocumentUploadComponent,
    SpecialEnrollmentEventDocumentUploadIchraAndQsehraComponent,
    SpecialEnrollmentEventInfoComponent,
    DocumentOrderFormComponent,
    CommonFormMemberLookupComponent,
    WholeHealthBalanceMemberLookupComponent,
    WhbConsumerLoginComponent,
    SendOutlineOfCoverageComponent,
    SendOutlineOfCoverageReviewComponent,
    PageDsnpEnrollmentComponent,
    AdaptiveYearSelectorComponent,
    SpecialEnrollmentEventSelectorComponent,
    SpecialEnrollmentEventReasonComponent,
    DynamicSpecialEnrollmentEventDocumentUpload,
    SpecialEnrollmentDateOfLifeEventComponent,
    AgentCertificateComponent,
    NoteEditorModalComponent,
    SpecialEnrollmentDateOfLifeEventProxyComponent,
    SpecialEnrollmentEventSelectorProxyComponent,
    SpecialEnrollmentSinglePageProxyComponent,
    DateOfLifeEventSinglePageProxyFormComponent,
    LifeEventSinglePageProxyFormComponent,
    ApplicableCircumstanceSinglePageProxyFormComponent,
    PageCreateFamilySpecialEnrollmentComponent,
    DateOfBirthInputComponent,
    MassUploadFormControlComponent,
    MassUploadHiosIdFormControlComponent,
    MassUploadZipCodeFormControlComponent,
    MassUploadCountyFormControlComponent,
    MassUploadEffectiveDateFormControlComponent,
    MassUploadStatusFormControlComponent,
    MassUploadPlanRegionFormControlComponent,
    MassUploadStateFormControlComponent,
    MassUploadDateFormControlComponent
  ],
  providers: [
    { provide: FormPageActionsService, useClass: ShopXFormPageActionsService },
    {
      provide: '__DEFINITELY_NOT_ENTRY_COMPONENTS__',
      // IMPORTANT: All Entry Components for dynamic form insertion MUST be included here
      // Or will be dropped when you do an optimized build by tree shaking.
      // This will look like it works in your DEVELOPMENT builds but FAIL in production builds.
      // You will see the following Error if this happens:
      // ERROR TypeError: Cannot read properties of undefined (reading 'ecmp')
      /**
       * NOTE: 2025-04-21 - the angular upgrade from v15 to v16 says:
       * "entryComponents is no longer available and any reference to it can be removed from the @NgModule and @Component public APIs.""
       * 
       * We used this workaround, parking things in a providers section, to avoid tree-shaking breaking this, and while Sidekick AI mentioned that we should
       * confidentally remove this - removing it just gets us back to where we were before entryComponents. So we'll retain this workaround.
       */
      useValue: [
        AddControlsComponent,
        addWhbQuestionComponent,
        AgencySelectorDropdownComponent,
        ApplicantInfoReviewComponent,
        AuthRepSignComponent,
        ByteFormatterPipe,
        CoverageDropdownSelectComponent,
        CustomRadioInputComponent,
        AutoCompleteInputAddressesComponent,
        CustomStatementAuthComponent,
        CustomZipCodeLabelComponent,
        DependentsComponent,
        EffectiveDateAttestationComponent,
        ReviewEffectiveDateAttestationComponent,
        EntryZipCountyInputsComponent,
        EntryZipCountyReviewComponent,
        FileDisplayComponent,
        FormDoctorInformation,
        FormDoctorInformationReview,
        HealthCheckMedicationComponent,
        HealthCheckMedicationReviewComponent,
        HyperlinkResetCloseComponent,
        IndividualComponent,
        IndividualMarketEffectiveDateSelectComponent,
        IndividualPageReviewV2Component,
        IndividualPageReviewComponent,
        InnerHtmlComponent,
        LoadFormComponent,
        MappedContentComponent,
        MedicareInfoValidatorComponent,
        PageAgentConfirmationComponent,
        PageCreateFamilyComponent,
        PageGuaranteedIssueEligibilityComponent,
        PageIndividualPlanEnrollmentComponent,
        PagePreauthorizationComponent,
        PagePreauthAndEligibilityComponent,
        PagePublicConfirmationComponent,
        PageReviewComponent,
        PlanEnrollmentComponent,
        ProducerFileUploadComponent,
        ProducerFileUploadFormComponent,
        RequiredDocsUploadFormComponent,
        RequiredDocsUploadReviewComponent,
        DynamicDocsUploadSpecialEnrollmentComponent,
        SendSoaPageComponent,
        SoaStatusLookupComponent,
        SpousalPartnerComponent,
        StatementsOfAuthorizationComponent,
        TextAreaComponent,
        WholeHealthBalanceCheckboxComponent,
        PageIndividualOnExchangePlanEnrollmentComponent,
        PlanEnrollmentOnExchangeComponent,
        MarketplaceReviewApplicationComponent,
        MarketplaceAdvancePremiumTaxCreditComponent,
        MarketplaceNotificationAndAuthorizationComponent,
        MarketplaceProducerAuthorizationComponent,
        MarketplaceConsumerNpnComponent,
        PageIndividualOnExchangePlanEnrollmentPaymentComponent,
        MarketplacePaymentOptionsComponent,
        FormIndividualOnExchangePlanEnrollmentPaymentComponent,
        MarketplacePaymentInfoComponent,
        PagePlanChangeStartReviewComponent,
        PlanChangeMemberLookupComponent,
        PageSendReferralComponent,
        ViewPlansDropdownComponent,
        SpecialEnrollmentEventDocumentUploadComponent,
        SpecialEnrollmentEventDocumentUploadIchraAndQsehraComponent,
        SpecialEnrollmentEventInfoComponent,
        SpecialEnrollmentEventReasonComponent,
        RequiredDocsUploadSpecialEnrollmentComponent,
        FileDisplayWithDropdownComponent,
        FileDisplayWithModalComponent,
        DocumentOrderFormComponent,
        CommonFormMemberLookupComponent,
        WholeHealthBalanceMemberLookupComponent,
        DynamicSpecialEnrollmentEventDocumentUpload,
        WhbConsumerLoginComponent,
        SendOutlineOfCoverageComponent,
        SendOutlineOfCoverageReviewComponent,
        PageDsnpEnrollmentComponent,
        AdaptiveYearSelectorComponent,
        AgentCertificateComponent,
        NoteEditorModalComponent,
        DateOfBirthInputComponent,
        SpecialEnrollmentDateOfLifeEventProxyComponent,
        SpecialEnrollmentEventSelectorProxyComponent,
        SpecialEnrollmentSinglePageProxyComponent,
        PageCreateFamilySpecialEnrollmentComponent,
        MassUploadFormControlComponent,
        MassUploadHiosIdFormControlComponent,
        MassUploadZipCodeFormControlComponent,
        MassUploadCountyFormControlComponent,
        MassUploadEffectiveDateFormControlComponent,
        MassUploadStatusFormControlComponent,
        MassUploadPlanRegionFormControlComponent,
        MassUploadStateFormControlComponent,
        MassUploadDateFormControlComponent
      ]
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class FormWrappersModule {

  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist('sxe-plan-enrollment-form', PlanEnrollmentComponent);
        this.createElementIfDoesNotExist('sxe-whole-health-balance-checkbox', WholeHealthBalanceCheckboxComponent);
        this.createElementIfDoesNotExist('sxe-applicant-info-review', ApplicantInfoReviewComponent);
        this.createElementIfDoesNotExist('sxe-form-individual-on-exchange-plan-enrollment-payment', FormIndividualOnExchangePlanEnrollmentPaymentComponent);
        this.createElementIfDoesNotExist('sxe-special-enrollment-event-selector', SpecialEnrollmentEventSelectorComponent);
        this.createElementIfDoesNotExist('sxe-special-enrollment-event-reason', SpecialEnrollmentEventReasonComponent);
        this.createElementIfDoesNotExist('sxe-special-enrollment-date-of-life-event', SpecialEnrollmentDateOfLifeEventComponent);
      }
    });
  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, {
        injector: this.injector
      });
      customElements.define(elementName, customElement);
    }
  }
  ngDoBootstrap() { }
}
